module.exports = __webpack_public_path__ + "img/network-2.7d4f6bcd.png";